import {
    Framerate,
    FramerateProfileResponseItem
} from "../../../common/api/orders-api/framerate-profile/responses/FramerateProfileResponseItem";

export interface FramerateProfileListingItem {
    id: string;
    name: string;
    mappings: Record<Framerate, string>;
    updatedDate: Date;
    isModified?: boolean;
}

export const mapToFramerateProfileListingItem = (item: FramerateProfileResponseItem): FramerateProfileListingItem => {
    return {
        id: item.id,
        name: item.name,
        mappings: {
            23.98: item.mappings["23.98"],
            29.97: item.mappings["29.97"],
            24: item.mappings["24"],
            25: item.mappings["25"],
            30: item.mappings["30"],
            50: item.mappings["50"],
            59.94: item.mappings["59.94"],
            60: item.mappings["60"],
            OTHER: item.mappings["OTHER"]
        },
        updatedDate: new Date(item.audit.updatedDate)
    };
};
